<template>
  <div class="order-detail-boxshadow">
    <div class="order-detail-list">
      <div class="order-detail-item">
        <span> 受理组：{{ BasicData.deal_groups_name }} </span>
        <span>
          <el-button
            type="primary"
            size="mini"
            @click="selectPopupShow()"
          >修改/增加</el-button>
        </span>
      </div>
      <div class="order-detail-item">
        <span> 受理组负责人：{{ BasicData.deal_persons_name }} </span>
        <span>
        </span>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="complaint-action-checkbox">
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            v-for="option in groupList"
            :key="option.key"
            :label="option.key"
          >
            {{ option.lable }}
          </el-checkbox>
        </el-checkbox-group>
        <div class="complaint-action-btn">
          <el-button
            size="mini"
            @click="show = false"
          >取消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="loading"
            @click="workDealGroupEdit"
          >提交</el-button>
        </div>

      </div>

    </van-popup>
  </div>
</template>

<script>
import complaintService from "@/apis/complaint/index.js";
import { throttle } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "complaintWorkAction",
  props: {
    BasicData: {
      default() {
        return {};
      },
    },
    userInfo: {
      default() {
        return {};
      },
    },
  },
  watch: {
    BasicData: {
      handler(newVal) {
        if (newVal.deal_groups) {
          this.checkList = newVal.deal_groups.split(",");
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      allEnum: {},
      show: false,
      checkList: [],
      groupList: [],
      loading: false,
    };
  },
  created() {
    this.getComplaintAllEnum();
    this.getGroupsByLevel();
  },
  methods: {
    workDealGroupEdit: throttle(function () {
      const { checkList, userInfo } = this;
      if (checkList.length === 0) {
        Message({
          message: "至少选择一个处理组",
          type: "error",
        });
        return;
      }
      const params = {
        center_work_id: this.BasicData.Id,
        deal_groups: this.checkList.join(","),
        user_id: userInfo.user_id,
        user_name: userInfo.user_name,
      };
      this.loading = true;

      complaintService
        .workDealGroupEdit(params)
        .then(() => {
          this.show = false;
          this.loading = false;
          this.$emit("workMyWorkDetail");
        })
        .catch(() => {
          this.loading = false;
        });
    }, 500),
    selectPopupShow() {
      this.show = true;
    },
    getComplaintAllEnum() {
      complaintService.getComplaintAllEnum().then((res) => {
        this.allEnum = res;
      });
    },
    getGroupsByLevel() {
      const params = {
        complaint_level: "1,2",
      };
      complaintService.getGroupsByLevel(params).then((res) => {
        const groupList = [];
        Object.keys(res).forEach((key) => {
          groupList.push({
            key,
            lable: res[key],
          });
        });
        this.groupList = groupList;
      });
    },
  },
};
</script>

<style lang="scss">
.complaint-action-checkbox {
  padding: 20px 30px;
  .el-checkbox-group,
  .el-radio-group {
    display: flex;
    flex-direction: column;
  }
  .el-radio,
  .el-checkbox {
    margin-bottom: 10px;
  }
}
.complaint-action-btn {
  margin-top: 20px;
}
</style>